export default "__VITE_ASSET__54e0f255__"